import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { getChaptersApi } from '../api';
import SourcePdfContent from '../SourcePdfContent';
import CitationSource from '../CitationSource';
import ChapterSourceReader from '../ChapterSourceReader';
import './SourcePage.css';

export default function SourcePagePage() {
  const { bookId, page: pageParam } = useParams();
  const [searchParams] = useSearchParams();
  const page = Number(pageParam);
  const validPage = Number.isInteger(page) && page > 0 && page <= 2147483647;
  const chunkId = searchParams.get('chunk');
  const explicitChapter = chunkId ? null : searchParams.get('chapter');
  const legacyChapterLink = !chunkId && !explicitChapter && searchParams.get('view') === 'pdf';
  const [legacy, setLegacy] = useState<{ book: string; page: number; chapter?: string }>();
  useEffect(() => {
    if (!bookId || !legacyChapterLink) return;
    let cancelled = false;
    void getChaptersApi(bookId).then(rows => {
      if (!cancelled) setLegacy({ book: bookId, page, chapter: rows.find(row => row.page_start === page)?.id });
    }).catch(() => { if (!cancelled) setLegacy({ book: bookId, page }); });
    return () => { cancelled = true; };
  }, [bookId, page, legacyChapterLink]);
  if (!bookId || !validPage) return <main className="container source-page-wrap"><div className="source-page-state" role="alert">原文页地址无效</div></main>;
  if (legacyChapterLink && (legacy?.book !== bookId || legacy.page !== page)) return <main className="container source-page-wrap"><div className="source-page-state" role="status">正在读取章节目录…</div></main>;
  const chapter = explicitChapter || (legacyChapterLink ? legacy?.chapter : undefined);
  if (chapter) return <ChapterSourceReader key={`${bookId}:${chapter}`} bookId={bookId} chapterId={chapter} requestedPage={page} explicitTitle={searchParams.get('cover') === '1'} />;
  return (
    <main className="container source-page-wrap">
      <div className="source-page-head">
        <div>
          <h1>原文阅读</h1>
        </div>
        {bookId && <Link className="btn" to={`/book/${encodeURIComponent(bookId)}`}>返回图书</Link>}
      </div>
      {chunkId ? <CitationSource key={`${chunkId}:${page}`} bookId={bookId} page={page} chunkId={chunkId} /> : <SourcePdfContent key={`${bookId}:${page}`} bookId={bookId} page={page} initialMode={searchParams.get('view') === 'pdf' ? 'pdf' : undefined} />}
    </main>
  );
}
